import * as React from 'react';
import { SVGProps } from 'react';

const IconStringSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 1H3v1h6V1ZM3 3h6v1H3V3ZM8.5 5h-5v1.25H2.25v2.722L1 9.616c0 1.04.844 1.884 1.884 1.884h.29l.326-.653h1.25l.327.653h1.846l.327-.653H8.5l.327.653h.289c1.04 0 1.884-.844 1.884-1.884l-1.25-.644V6.25H8.5V5Z" />
  </svg>
);
export default IconStringSizeXs;
